window.addEventListener("error", function (event) {
  if (event?.message?.includes("Loading chunk")) {
    console.warn("Chunk loading error. Reloading...");
    window.location.reload(); // força a recarga com arquivos atualizados
  }
})
